import React from "react";


// --- Doughnut -------------------------------------------------
export default function Doughnut({ value, darkMode = true }) {
  const percentage = value;
  const radius = 32;
  const strokeWidth = 10;
  const circumference = 2 * Math.PI * radius;
  const offset = circumference - (percentage / 100) * circumference;
  
  const OMNISCAN_BLUE = "#20afe8";

  // ==== DARK MODE STYLING ======================================
  const darkBaseRing = "rgba(255,255,255,0.12)";   // subtle matte ring
  const darkText = "rgba(255,255,255,0.85)";
  const darkStroke = OMNISCAN_BLUE;       // but toned via opacity
  const darkStrokeOpacity = 0.65;

  // ==== LIGHT MODE STYLING =====================================
  const lightBaseRing = "rgba(0,0,0,0.12)";
  const lightText = "rgba(0,0,0,0.75)";
  const lightStroke = OMNISCAN_BLUE;
  const lightStrokeOpacity = 0.75;

  // Pick correct palette depending on mode
  const baseRing = darkMode ? darkBaseRing : lightBaseRing;
  const textColor = darkMode ? darkText : lightText;
  const stroke = darkMode ? darkStroke : lightStroke;
  const strokeOpacity = darkMode ? darkStrokeOpacity : lightStrokeOpacity;
  
  
  

  return (
    <div
      style={{
        position: "relative",
        width: 80,
        height: 80,
        display: "flex",
        alignItems: "center",
        justifyContent: "center"
      }}
    >
      <svg width="80" height="80">
        {/* Base Ring */}
        <circle
          cx="40"
          cy="40"
          r={radius}
          stroke={baseRing}
          strokeWidth={strokeWidth}
          fill="none"
        />

        {/* Animated Utilisation Ring */}
        <circle
          cx="40"
          cy="40"
          r={radius}
          stroke={stroke}
          strokeOpacity={1}
          strokeWidth={strokeWidth}
          fill="none"
          strokeDasharray={circumference}
          strokeDashoffset={offset}
          strokeLinecap="round"
          style={{ transition: "stroke-dashoffset 0.6s ease" }}
        />
      </svg>

      {/* Percentage Label */}
      <div
        style={{
          position: "absolute",
          fontWeight: "bold",
          fontSize: 18,
          color: textColor
        }}
      >
        {percentage}%
      </div>
    </div>
  );
}
